var map = {
	"./00_OFF.svg": 57792,
	"./00_ON.svg": 77579,
	"./01_OFF.svg": 42291,
	"./01_ON.svg": 74602,
	"./02_OFF.svg": 21507,
	"./02_ON.svg": 20929,
	"./03_OFF.svg": 95177,
	"./03_ON.svg": 68370,
	"./empty_OFF.svg": 59924,
	"./empty_ON.svg": 6437
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 43257;